/** One OAuth door. The provider names itself; the action says what pressing it does. */

import type { CSSProperties, MouseEvent } from "react";

import { cn } from "@/lib/cn";

import "./ProviderButton.css";

export type Provider = "google" | "discord" | "facebook" | "twitch" | "kick";

const NAME: Record<Provider, string> = {
  google: "Google",
  discord: "Discord",
  facebook: "Facebook",
  twitch: "Twitch",
  kick: "Kick",
};

export interface ProviderButtonProps {
  readonly provider: Provider;
  /** The verb, such as Sign in or Link. */
  readonly action?: string;
  readonly loading?: boolean;
  readonly disabled?: boolean;
  readonly onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  readonly className?: string;
  readonly style?: CSSProperties;
}

export function ProviderButton({
  provider,
  action = "Continue",
  loading = false,
  disabled = false,
  onClick,
  className,
  style,
}: ProviderButtonProps) {
  return (
    <button
      type="button"
      disabled={disabled || loading}
      aria-busy={loading ? true : undefined}
      onClick={onClick}
      style={style}
      className={cn("al-provider", `al-provider-${provider}`, className)}
    >
      {loading ? (
        <span className="al-spinner" aria-hidden="true" />
      ) : (
        <span className="al-provider-mark" aria-hidden="true">
          {NAME[provider].slice(0, 1)}
        </span>
      )}
      <span className="al-provider-label">
        {action} with {NAME[provider]}
      </span>
    </button>
  );
}
